/**
 * Check if object is empty
 *
 * @param {Object} obj object to check
 * @returns {boolean} true if object does not have keys
 */
const isEmpty = obj => Object.keys(obj).length === 0;

/**
 * Pick the given fields from an object
 *
 * @param {Object} obj object to pick fields from
 * @param {string[]} fields fields to retrieve from obj
 * @returns {Object} object with fields that where not undefined or null
 */
const pickFields = (obj, fields) => {
  return fields.reduce((acc, key) => {
    if (obj[key] !== undefined && obj[key] !== null) {
      acc[key] = obj[key];
    }
    return acc;
  }, {});
};

/**
 * Remove fields that are empty strings
 *
 * @param {Object} obj object to select fields from
 * @returns {Object} object with fields that where not an empty string
 */
const removeEmptyFields = obj => {
  return Object.keys(obj).reduce((acc, key) => {
    const value = obj[key];
    if (typeof value !== 'string' || value.trim() !== '') {
      acc[key] = obj[key];
    }
    return acc;
  }, {});
};

export { isEmpty, pickFields, removeEmptyFields };
